module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prescnoVerify paddingTop45"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v(" 电子处方审核信息")]), _vm._v(" "), _c('tab', {
    staticClass: "tabHeader",
    attrs: {
      "active-color": "#4ba7e8",
      "bar-active-color": "#4ba7e8",
      "prevent-default": ""
    },
    on: {
      "on-before-index-change": _vm.HeaderswitchTab
    },
    model: {
      value: (_vm.bigTabIndex),
      callback: function($$v) {
        _vm.bigTabIndex = $$v
      },
      expression: "bigTabIndex"
    }
  }, [_c('tab-item', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("门诊病历")]), _vm._v(" "), _c('tab-item', [_vm._v("处方信息")]), _vm._v(" "), _c('tab-item', [_vm._v("检验信息")]), _vm._v(" "), _c('tab-item', [_vm._v("检查信息")])], 1), _vm._v(" "), (_vm.bigTabIndex == 0) ? _c('div', {
    staticClass: "content"
  }, [_c('cell', {
    attrs: {
      "title": "姓名",
      "value": this.personInfo.patientName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "性别",
      "value": this.personInfo.sXbDm
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "年龄",
      "value": this.personInfo.age
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "出生日期",
      "value": this.personInfo.birthday
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "门诊病历号",
      "value": this.opdinfo.opcRegistrationNo
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "主诉",
      "value": this.opdinfo.chiefComplaint
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "现病史",
      "value": this.opdinfo.hpi
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "既往史",
      "value": this.opdinfo.pastHistory
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "个人史",
      "value": this.opdinfo.personalHistory
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "过敏史",
      "value": this.opdinfo.allergicHistory
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "处理意见",
      "value": this.opdinfo.adviceDesc
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "传染病",
      "value": this.opdinfo.infectionsReg == '1' ? '是' : '否'
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "主要诊断",
      "value": this.opdinfo.disease
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bigTabIndex == 1) ? _c('div', {
    staticClass: "content"
  }, [_c('flexbox', [_c('flexbox-item', {
    staticClass: "cfj"
  }, [_c('div', {
    staticClass: "bigTitle"
  }, [_vm._v("审核记录")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "cfj",
    staticStyle: {
      "color": "#cb4734"
    }
  }, [_c('div', [_vm._v(_vm._s(this.checkInfo.ORDERSTATUS))])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("审核药师：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc"
  }, [_c('div', [_vm._v(_vm._s(this.checkInfo.EMPLOYEENAME))])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("审核时间：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc"
  }, [_c('div', [_vm._v(_vm._s(this.checkInfo.CHECK_DATE))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px dashed #707070",
      "height": "2px",
      "overflow": "hidden",
      "margin": "0 5px"
    }
  }), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "cfj"
  }, [_c('div', {
    staticClass: "bigTitle"
  }, [_vm._v("处方笺")])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("开方时间：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc"
  }, [_c('div', [_vm._v(_vm._s(this.opdinfo.jzDate))])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("患者信息：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 2
    }
  }, [_c('div', [_vm._v(_vm._s(this.personInfo.patientName))])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 1
    }
  }, [_c('div', [_vm._v(_vm._s(this.personInfo.sXbDm))])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 2
    }
  }, [_c('div', [_vm._v(_vm._s(this.personInfo.age) + "岁")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 4
    }
  }, [_c('div', [_vm._v(_vm._s(this.personInfo.birthday))])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("诊断：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc"
  }, [_c('div', [_vm._v(_vm._s(this.opdinfo.diseaseName))])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("RP：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc",
    staticStyle: {
      "margin-left": "0 !important"
    }
  }, _vm._l((this.prescnos), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "drugInfo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.drugName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.takeTotalDrugDesc))])]), _vm._v(" "), _c('div', [_vm._v("sig: "), _c('span', [_vm._v(_vm._s(item.orderDoseQtyDesc))]), _c('span', [_vm._v(_vm._s(item.arcInstr))]), _c('span', [_vm._v(_vm._s(item.arcFreq))])])])
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px dashed #707070",
      "height": "2px",
      "overflow": "hidden",
      "margin": "0 5px 10px"
    }
  }), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("开方医生：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', [_vm._v(_vm._s(this.opdinfo.doctorName))])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc"
  }, [(this.opdinfo.doctorTel != '') ? _c('a', {
    attrs: {
      "href": 'tel:' + this.opdinfo.doctorTel
    }
  }, [_c('x-button', {
    attrs: {
      "mini": "",
      "type": "primary"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua",
    staticStyle: {
      "font-size": "12px",
      "vertical-align": "middle",
      "margin-right": "2px"
    }
  }), _vm._v("拨打电话")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("开方科室：")])]), _vm._v(" "), _c('flexbox-item', {
    staticClass: "flexPresc"
  }, [_c('div', [_vm._v(_vm._s(this.opdinfo.doctorDepartment))])])], 1), _vm._v(" "), _c('flexbox', [_c('flexbox-item', {
    staticClass: "flexPresc",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("医生备注：")])]), _vm._v(" "), _vm._l((this.prescnos), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n              " + _vm._s(item.overBalanceRemark) + "\n         ")])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "margin": "15px 10px",
      "width": "50%"
    },
    attrs: {
      "disabled": this.opdinfo.orderStatus != '1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkSuccess()
      }
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "margin": "15px 10px",
      "width": "50%"
    },
    attrs: {
      "disabled": this.opdinfo.orderStatus != '1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkFail()
      }
    }
  }, [_vm._v("审核不通过")])], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px 0"
    }
  }, [_vm._v("超药品说明书同意书")]), _vm._v(" "), _c('table', {
    staticClass: "drugsTable",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.lookArry), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.lookArry.length != 0),
        expression: "lookArry.length !=0"
      }]
    }, [_c('td', [_vm._v(_vm._s(item.CREATED_DATE))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.TITLE))]), _vm._v(" "), _c('td', [_c('img', {
      attrs: {
        "src": 'data:image/gif;base64,' + item.KEY_PIC
      }
    })])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lookArry.length == 0),
      expression: "lookArry.length == 0"
    }]
  }, [_c('td', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("暂无数据！")])])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.bigTabIndex == 2) ? _c('div', [_c('div', {
    staticClass: "page-loadmore"
  }, [_c('div', {
    staticClass: "page-loadmore-wrapper"
  }, [_c('mt-loadmore', {
    ref: "labLoadmore",
    attrs: {
      "bottom-method": _vm.loadLabBottom,
      "bottom-all-loaded": _vm.labAllLoaded
    },
    on: {
      "bottom-status-change": _vm.handleLabBottomChange
    }
  }, [_c('ul', {
    staticClass: "page-loadmore-list"
  }, [_c('x-table', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "cell-bordered": false,
      "content-bordered": false
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F7F7F7"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("项目名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("检验值")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("高低")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("参考值")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("检验日期")])])]), _vm._v(" "), _c('tbody', _vm._l((this.labResults), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.inspecValue))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(item.highLow))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.highLowGap))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(item.doCheckTime))])])
  }))]), _vm._v(" "), _c('load-more', {
    attrs: {
      "show-loading": _vm.labLoadmoreShow,
      "tip": _vm.labLoadmoreTxt,
      "background-color": "#fbf9fe"
    }
  })], 1)])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.bigTabIndex == 3) ? _c('div', [_c('div', {
    staticClass: "page-loadmore"
  }, [_c('div', {
    staticClass: "page-loadmore-wrapper"
  }, [_c('mt-loadmore', {
    ref: "examLoadmore",
    attrs: {
      "bottom-method": _vm.loadExamBottom,
      "bottom-all-loaded": _vm.examAllLoaded
    },
    on: {
      "bottom-status-change": _vm.handleExamBottomChange
    }
  }, [_c('ul', {
    staticClass: "page-loadmore-list"
  }, [_c('x-table', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "cell-bordered": false,
      "content-bordered": false
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F7F7F7"
    }
  }, [_c('th', [_vm._v("检查类型")]), _vm._v(" "), _c('th', [_vm._v("检查日期")]), _vm._v(" "), _c('th', [_vm._v("检查值")])])]), _vm._v(" "), _c('tbody', _vm._l((this.examResults), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.jclx))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.reportDate))]), _vm._v(" "), _c('td', {
      attrs: {
        "title": "点击查看检查详情"
      },
      on: {
        "click": function($event) {
          _vm.showExamDetail(item.reportResult)
        }
      }
    }, [_vm._v(" " + _vm._s(item.reportConclusion))])])
  }))]), _vm._v(" "), _c('load-more', {
    attrs: {
      "show-loading": _vm.examLoadmoreShow,
      "tip": _vm.examLoadmoreTxt,
      "background-color": "#fbf9fe"
    }
  })], 1)])], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "23%"
    }
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "52%"
    }
  }, [_vm._v("同意书名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("医生签名")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-160afe32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/prescnoVerifyProject/prescnoVerify.vue
// module id = xPxv
// module chunks = 6